import React from 'react'
import { DialogContent, DialogContentProps } from '@material-ui/core'
import { createStyles, Theme, withStyles } from '@material-ui/core/styles'

interface IYumDialogContent extends DialogContentProps {}

const YumDialogContent = withStyles((theme: Theme) =>
  createStyles({
    root: { width: '400px', maxWidth: '100%', paddingTop: 0, paddingBottom: 0 },
  }),
)(({ children, classes, ...props }: IYumDialogContent) => {
  return (
    <DialogContent classes={classes} {...props}>
      {children}
    </DialogContent>
  )
})

export default YumDialogContent
